// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Homepage destination carousels (Global Hotspots, Weekend, Visa-Free) ===== */
/* Desktop header stays out of the first mobile paint without waiting for MUI sx. */
@media (max-width: 899.98px) {
  .homepage-yovo-header-host {
    display: none;
  }
}

.homepage-destination-carousel {
  /* Keeps arrow stacking local so they do not paint over the page / sticky scrollbar */
  isolation: isolate;
  -webkit-tap-highlight-color: transparent;
}

/* ===== Homepage FAQ ===== */
.homepage-faq-section {
  box-sizing: border-box;
  width: 100%;
  padding: 80px;
  padding-top: 0;
  background: #fbfbfd;
  -webkit-tap-highlight-color: transparent;
  overflow-x: hidden;
}

.homepage-faq-heading {
  width: 100%;
  margin: 0 0 40px !important;
  color: #1a1827;
  word-break: break-word;
}

.homepage-faq-list {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
}

.homepage-faq-item {
  width: 100%;
  border-bottom: 1px solid #f3f3f7;
}

.homepage-faq-trigger {
  display: flex;
  width: 100%;
  min-height: 72px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 0;
  border: 0;
  background: transparent;
  color: #1a1827;
  cursor: pointer;
  font: inherit;
  text-align: left;
  touch-action: manipulation;
}

.homepage-faq-trigger:focus-visible {
  outline: 2px solid #1a1827;
  outline-offset: 4px;
}

.homepage-faq-question {
  flex: 1 1 auto;
  min-width: 0;
  color: #1a1827;
  word-break: break-word;
}

.homepage-faq-icon {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  color: #1a1827;
  font-size: 24px;
  font-weight: 400;
  line-height: 1;
  transform-origin: center;
  transition: transform 0.2s ease;
}

.homepage-faq-icon svg {
  width: 24px;
  height: 24px;
  font-size: 24px;
}

.homepage-faq-trigger[aria-expanded='true'] {
  padding-bottom: 16px;
}

.homepage-faq-answer {
  width: 100%;
  margin: 0 0 24px !important;
  color: #434151;
  word-break: break-word;
}

/* ===== Footer ===== */

.yovo-footer {
  box-sizing: border-box;
  overflow-x: hidden;
}

.yovo-footer-brand-title {
  color: #FBFBFB;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.75rem;
  white-space: nowrap;
}

.yovo-footer-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  min-width: 0;
  flex: 1 1;
}

.yovo-footer-col-title {
  color: #FBFBFB;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.4rem;
  white-space: normal;
  word-wrap: break-word;
}

.yovo-footer-col-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.yovo-footer-link {
  color: #FBFBFB;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.yovo-footer-social-link {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

/* ===== Mobile + Tablet (<1024) ===== */
@media (max-width: 1023px) {
  .yovo-footer {
    padding: 40px 20px 60px !important;
  }

  .yovo-footer-inner {
    flex-direction: column !important;
    gap: 32px !important;
  }

  .yovo-footer-columns {
    flex-direction: column !important;
    gap: 28px !important;
    width: 100% !important;
  }

  .yovo-footer-col {
    flex: 1 1 100%;
    width: 100%;
  }

  .yovo-footer-col-title {
    font-size: 1rem;
  }

  .yovo-footer-link {
    font-size: 1rem;
    min-height: 44px;
    display: flex;
    align-items: center;
  }
}

@media (max-width: 899px) {
  .homepage-faq-section {
    padding: 48px 24px;
    padding-top: 0;
  }

  .homepage-faq-heading {
    margin-bottom: 24px !important;
  }

  .homepage-faq-trigger {
    min-height: 64px;
    padding: 20px 0;
  }
}

@media (max-width: 599px) {
  .homepage-faq-section {
    padding: 40px 16px;
    padding-top: 0;
  }

  .homepage-faq-trigger {
    align-items: flex-start;
    min-height: 60px;
    padding: 18px 0;
  }

  .homepage-faq-icon {
    margin-top: 1px;
  }
}

/* ===== iOS safe area ===== */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .yovo-footer {
    padding-bottom: calc(60px + env(safe-area-inset-bottom)) !important;
  }

  @media (max-width: 1023px) {
    .yovo-footer {
      padding-bottom: calc(40px + env(safe-area-inset-bottom)) !important;
    }
  }
}

/* ===== AI Travel Guide — greeting + input + side icon (flight / train / hotel) ===== */
.homepage-ai-travel-guide-row {
  box-sizing: border-box;
}

.homepage-ai-travel-guide-row--paired {
  align-items: flex-end;
  justify-content: flex-start;
  gap: clamp(8px, 1vw, 16px);
  width: 0;
  min-width: 100%;
  max-width: 100%;
}

@media (min-width: 900px) {
  .homepage-ai-travel-guide-row--paired {
    display: flex;
  }
}

.homepage-ai-travel-guide-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  align-items: stretch;
  gap: clamp(8px, 1vw, 13px);
}

.homepage-ai-travel-guide-side-visual {
  display: flex;
  flex: 0 0 auto;
  align-items: flex-end;
  justify-content: center;
  min-height: 0;
  overflow: hidden;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  line-height: 0;
  transition: opacity 0.15s ease;
}

.homepage-ai-travel-guide-side-visual img {
  display: block;
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  object-position: bottom center;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

@media (min-width: 900px) and (max-width: 1199px) {
  .homepage-ai-travel-guide-row--paired {
    gap: clamp(6px, 0.85vw, 12px);
  }
}

@media (min-width: 1200px) {
  .homepage-ai-travel-guide-row--paired {
    gap: clamp(10px, 1.25vw, 18px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/styles/Homepage.css"],"names":[],"mappings":"AAAA,qFAAqF;AACrF,mFAAmF;AACnF;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qFAAqF;EACrF,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;AACxB;;AAEA,uBAAuB;;AAEvB;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iGAAiG;EACjG,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,SAAW;AACb;;AAEA;EACE,cAAc;EACd,iGAAiG;EACjG,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA,wCAAwC;AACxC;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,iCAAiC;IACjC,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,mEAAmE;EACrE;;EAEA;IACE;MACE,mEAAmE;IACrE;EACF;AACF;;AAEA,wFAAwF;AACxF;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* ===== Homepage destination carousels (Global Hotspots, Weekend, Visa-Free) ===== */\n/* Desktop header stays out of the first mobile paint without waiting for MUI sx. */\n@media (max-width: 899.98px) {\n  .homepage-yovo-header-host {\n    display: none;\n  }\n}\n\n.homepage-destination-carousel {\n  /* Keeps arrow stacking local so they do not paint over the page / sticky scrollbar */\n  isolation: isolate;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* ===== Homepage FAQ ===== */\n.homepage-faq-section {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 80px;\n  padding-top: 0;\n  background: #fbfbfd;\n  -webkit-tap-highlight-color: transparent;\n  overflow-x: hidden;\n}\n\n.homepage-faq-heading {\n  width: 100%;\n  margin: 0 0 40px !important;\n  color: #1a1827;\n  word-break: break-word;\n}\n\n.homepage-faq-list {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.homepage-faq-item {\n  width: 100%;\n  border-bottom: 1px solid #f3f3f7;\n}\n\n.homepage-faq-trigger {\n  display: flex;\n  width: 100%;\n  min-height: 72px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 24px 0;\n  border: 0;\n  background: transparent;\n  color: #1a1827;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  touch-action: manipulation;\n}\n\n.homepage-faq-trigger:focus-visible {\n  outline: 2px solid #1a1827;\n  outline-offset: 4px;\n}\n\n.homepage-faq-question {\n  flex: 1 1 auto;\n  min-width: 0;\n  color: #1a1827;\n  word-break: break-word;\n}\n\n.homepage-faq-icon {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  align-items: center;\n  justify-content: center;\n  color: #1a1827;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 1;\n  transform-origin: center;\n  transition: transform 0.2s ease;\n}\n\n.homepage-faq-icon svg {\n  width: 24px;\n  height: 24px;\n  font-size: 24px;\n}\n\n.homepage-faq-trigger[aria-expanded='true'] {\n  padding-bottom: 16px;\n}\n\n.homepage-faq-answer {\n  width: 100%;\n  margin: 0 0 24px !important;\n  color: #434151;\n  word-break: break-word;\n}\n\n/* ===== Footer ===== */\n\n.yovo-footer {\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.yovo-footer-brand-title {\n  color: #FBFBFB;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 1.25rem;\n  font-weight: 700;\n  line-height: 1.75rem;\n  white-space: nowrap;\n}\n\n.yovo-footer-col {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  min-width: 0;\n  flex: 1 1 0;\n}\n\n.yovo-footer-col-title {\n  color: #FBFBFB;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1.4rem;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\n.yovo-footer-col-links {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.yovo-footer-link {\n  color: #FBFBFB;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5rem;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.yovo-footer-social-link {\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* ===== Mobile + Tablet (<1024) ===== */\n@media (max-width: 1023px) {\n  .yovo-footer {\n    padding: 40px 20px 60px !important;\n  }\n\n  .yovo-footer-inner {\n    flex-direction: column !important;\n    gap: 32px !important;\n  }\n\n  .yovo-footer-columns {\n    flex-direction: column !important;\n    gap: 28px !important;\n    width: 100% !important;\n  }\n\n  .yovo-footer-col {\n    flex: 1 1 100%;\n    width: 100%;\n  }\n\n  .yovo-footer-col-title {\n    font-size: 1rem;\n  }\n\n  .yovo-footer-link {\n    font-size: 1rem;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n  }\n}\n\n@media (max-width: 899px) {\n  .homepage-faq-section {\n    padding: 48px 24px;\n    padding-top: 0;\n  }\n\n  .homepage-faq-heading {\n    margin-bottom: 24px !important;\n  }\n\n  .homepage-faq-trigger {\n    min-height: 64px;\n    padding: 20px 0;\n  }\n}\n\n@media (max-width: 599px) {\n  .homepage-faq-section {\n    padding: 40px 16px;\n    padding-top: 0;\n  }\n\n  .homepage-faq-trigger {\n    align-items: flex-start;\n    min-height: 60px;\n    padding: 18px 0;\n  }\n\n  .homepage-faq-icon {\n    margin-top: 1px;\n  }\n}\n\n/* ===== iOS safe area ===== */\n@supports (padding-bottom: env(safe-area-inset-bottom)) {\n  .yovo-footer {\n    padding-bottom: calc(60px + env(safe-area-inset-bottom)) !important;\n  }\n\n  @media (max-width: 1023px) {\n    .yovo-footer {\n      padding-bottom: calc(40px + env(safe-area-inset-bottom)) !important;\n    }\n  }\n}\n\n/* ===== AI Travel Guide — greeting + input + side icon (flight / train / hotel) ===== */\n.homepage-ai-travel-guide-row {\n  box-sizing: border-box;\n}\n\n.homepage-ai-travel-guide-row--paired {\n  align-items: flex-end;\n  justify-content: flex-start;\n  gap: clamp(8px, 1vw, 16px);\n  width: 0;\n  min-width: 100%;\n  max-width: 100%;\n}\n\n@media (min-width: 900px) {\n  .homepage-ai-travel-guide-row--paired {\n    display: flex;\n  }\n}\n\n.homepage-ai-travel-guide-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-width: 0;\n  align-items: stretch;\n  gap: clamp(8px, 1vw, 13px);\n}\n\n.homepage-ai-travel-guide-side-visual {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: flex-end;\n  justify-content: center;\n  min-height: 0;\n  overflow: hidden;\n  pointer-events: none;\n  user-select: none;\n  line-height: 0;\n  transition: opacity 0.15s ease;\n}\n\n.homepage-ai-travel-guide-side-visual img {\n  display: block;\n  height: 100%;\n  width: 100%;\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n  object-position: bottom center;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n@media (min-width: 900px) and (max-width: 1199px) {\n  .homepage-ai-travel-guide-row--paired {\n    gap: clamp(6px, 0.85vw, 12px);\n  }\n}\n\n@media (min-width: 1200px) {\n  .homepage-ai-travel-guide-row--paired {\n    gap: clamp(10px, 1.25vw, 18px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
